import {
    GET_SIM_CARDS_REQUEST,
    GET_SIM_CARDS_SUCCESS,
    GET_SIM_CARDS_FAILURE,
    GET_TYPING_SIM_CARDS_REQUEST,
    GET_SIM_CARDS_STATUSES_REQUEST,
    GET_SIM_CARDS_STATUSES_SUCCESS,
    GET_SIM_CARDS_STATUSES_FAILURE,
    SUBMIT_SIM_CARDS_BATCH_REQUEST,
    SUBMIT_SIM_CARDS_BATCH_SUCCESS,
    SUBMIT_SIM_CARDS_BATCH_FAILURE,
    SUBMIT_SIM_CARDS_REQUEST,
    SUBMIT_SIM_CARDS_SUCCESS,
    SUBMIT_SIM_CARDS_FAILURE,
    SUBMIT_SIM_CARDS_STATUSES_REQUEST,
    SUBMIT_SIM_CARDS_STATUSES_SUCCESS,
    SUBMIT_SIM_CARDS_STATUSES_FAILURE,
    SET_STATE_SIM_CARDS,
    SET_SIMCARD_SELECTED,
    SUBMIT_SIMCARDS_VALIDATE_BATCH_REQUEST,
    SUBMIT_SIMCARDS_VALIDATE_BATCH_SUCCESS,
    SUBMIT_SIMCARDS_VALIDATE_BATCH_FAILURE,
    CLEAN_VALIDATED_SIMCARDS,
    GET_EXPORT_SIMCARDS_REQUEST,
    GET_EXPORT_SIMCARDS_SUCCESS,
    GET_EXPORT_SIMCARDS_FAILURE,
    GET_SIM_CARDS_SUBSTATUSES_REQUEST,
    GET_SIM_CARDS_SUBSTATUSES_SUCCESS,
    GET_SIM_CARDS_SUBSTATUSES_FAILURE,
    GET_HISTORY_SIM_CARDS_REQUEST,
    GET_HISTORY_SIM_CARDS_SUCCESS,
    GET_HISTORY_SIM_CARDS_FAILURE,
    PATCH_SIMCARDS_BATCH_REQUEST,
    PATCH_SIMCARDS_BATCH_SUCCESS,
    PATCH_SIMCARDS_BATCH_FAILURE
} from "../actions/simcards";
import { buildSimcards } from "../helpers/simcards";
const initialState = {
    fetching: false,
    simCards: [],
    simCard: {},
    total: 0,
    statuses: [],
    statuesFetching: false,
    history: [],
    historyFetching: false,
    substatuses: [],
    substatusesFetching: false,
    submitFetching: false,
    editFetching: false,
    submitSuccess: false,
    submitStatusesFetching: false,
    submitStatusesSucces: false,
    submitValidateBatchFetching: false,
    submitValidateBatchSuccess: false,
    simcardsBatchValidations: {},
    exportableFileName: null,
    fetchingExport: false,
    isReadyForPatch: false
};

export default (state = initialState, action) => {
    switch (action.type) {
        case GET_SIM_CARDS_REQUEST: {
            return {
                ...state,
                fetching: true
            };
        }
        case GET_SIM_CARDS_SUCCESS: {

            const newSimCards = action.payload.replace
                ? buildSimcards(action.payload.simCards)
                : state.simCards.concat(buildSimcards(action.payload.simCards));
                
            return {
                ...state,
                fetching: false,
                simCards: newSimCards,
                total: action.payload.total === 0 ? state.total : action.payload.total
            };
        }
        case GET_SIM_CARDS_FAILURE: {
            return {
                ...state,
                fetching: false
            };
        }
        case GET_TYPING_SIM_CARDS_REQUEST: {
            return {
                ...state,
                fetching: true
            };
        }
        case GET_SIM_CARDS_STATUSES_REQUEST: {
            return {
                ...state,
                statuses: [],
                statuesFetching: true
            };
        }
        case GET_SIM_CARDS_STATUSES_SUCCESS: {
            return {
                ...state,
                statuses: action.payload.statuses,
                statuesFetching: false
            };
        }
        case GET_SIM_CARDS_STATUSES_FAILURE: {
            return {
                ...state,
                statuesFetching: false
            };
        }
        case GET_SIM_CARDS_SUBSTATUSES_REQUEST: {
            return {
                ...state,
                substatuses: [],
                substatusesFetching: true
            };
        }
        case GET_SIM_CARDS_SUBSTATUSES_SUCCESS: {
            return {
                ...state,
                substatuses: action.payload.substatuses || action.payload.substatus || [],
                substatusesFetching: false
            };
        }
        case GET_SIM_CARDS_SUBSTATUSES_FAILURE: {
            return {
                ...state,
                substatusesFetching: false
            };
        }

        case GET_HISTORY_SIM_CARDS_REQUEST: {
            return {
                ...state,
                history: [],
                historyFetching: true
            };
        }
        case GET_HISTORY_SIM_CARDS_SUCCESS: {
            return {
                ...state,
                history: action.payload.history,
                historyFetching: false
            };
        }
        case GET_HISTORY_SIM_CARDS_FAILURE: {
            return {
                ...state,
                historyFetching: false
            };
        }
        case SUBMIT_SIM_CARDS_BATCH_REQUEST: {
            return {
                ...state,
                submitFetching: true,
                submitSuccess: false,
                isReadyForPatch: false
            };
        }
        case SUBMIT_SIM_CARDS_BATCH_SUCCESS: {
            return {
                ...state,
                submitFetching: false,
                submitSuccess: true,
                isReadyForPatch: true
            };
        }
        case SUBMIT_SIM_CARDS_BATCH_FAILURE: {
            return {
                ...state,
                submitFetching: false,
                submitSuccess: false,
                isReadyForPatch: false
            };
        }
        case SUBMIT_SIMCARDS_VALIDATE_BATCH_REQUEST: {
            return {
                ...state,
                submitValidateBatchFetching: true,
                submitValidateBatchSuccess: false
            };
        }
        case SUBMIT_SIMCARDS_VALIDATE_BATCH_SUCCESS: {
            return {
                ...state,
                submitValidateBatchFetching: false,
                submitValidateBatchSuccess: true,
                simcardsBatchValidations: action.payload.validations
            };
        }
        case SUBMIT_SIMCARDS_VALIDATE_BATCH_FAILURE: {
            return {
                ...state,
                submitValidateBatchFetching: false,
                submitValidateBatchSuccess: false
            };
        }
        case CLEAN_VALIDATED_SIMCARDS: {
            return {
                ...state,
                submitValidateBatchFetching: false,
                submitValidateBatchSuccess: false,
                simcardsBatchValidations: {}
            };
        }
        case SUBMIT_SIM_CARDS_REQUEST: {
            return {
                ...state,
                submitFetching: true,
                submitSuccess: false
            };
        }
        case SUBMIT_SIM_CARDS_SUCCESS: {
            return {
                ...state,
                submitFetching: false,
                submitSuccess: true
            };
        }
        case SUBMIT_SIM_CARDS_FAILURE: {
            return {
                ...state,
                submitFetching: false,
                submitSuccess: false
            };
        }
        case SUBMIT_SIM_CARDS_STATUSES_REQUEST: {
            return {
                ...state,
                submitStatusesFetching: true,
                submitStatusesSucces: false
            };
        }
        case SUBMIT_SIM_CARDS_STATUSES_SUCCESS: {
            return {
                ...state,
                submitStatusesFetching: false,
                submitStatusesSucces: true
            };
        }
        case SUBMIT_SIM_CARDS_STATUSES_FAILURE: {
            return {
                ...state,
                submitStatusesFetching: false,
                submitStatusesSucces: false
            };
        }
        case PATCH_SIMCARDS_BATCH_REQUEST: {
            return {
                ...state,
                editFetching: true,
                submitSuccess: false
            };
        }
        case PATCH_SIMCARDS_BATCH_SUCCESS: {
            return {
                ...state,
                editFetching: false,
                submitSuccess: true
            };
        }
        case PATCH_SIMCARDS_BATCH_FAILURE: {
            return {
                ...state,
                editFetching: false,
                submitSuccess: false
            };
        }
        case SET_STATE_SIM_CARDS: {
            return {
                ...state,
                ...action.payload
            };
        }
        case SET_SIMCARD_SELECTED: {
            return {
                ...state,
                simCard: action.payload.simcard
            };
        }
        case GET_EXPORT_SIMCARDS_REQUEST: {
            return {
                ...state,
                fetchingExport: true
            }
        }
        case GET_EXPORT_SIMCARDS_SUCCESS: {
            return {
                ...state,
                exportableFileName: action.payload.fileName,
                fetchingExport: false
            }
        }
        case GET_EXPORT_SIMCARDS_FAILURE: {
            return {
                ...state,
                fetchingExport: false
            }
        }
        default:
            return state;
    }
};
